var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FlexibleLayoutGrid,{attrs:{"layout":_setup.layout},scopedSlots:_vm._u([_vm._l((_setup.widgetDefinitions),function(widgetDefinition){return {key:`widget-${widgetDefinition.index}`,fn:function(){return [_c(_setup.WidgetContainer,{attrs:{"widgetDefinition":widgetDefinition}})]},proxy:true}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }